import React from 'react'
import { CellProps } from 'react-table'

import { LinkToRelatedOrder } from './LinkToRelatedOrder'
import { TableDataInvoice } from './types'

interface RelatedOrderCellProps extends CellProps<TableDataInvoice> {
  value: string
}

export const RelatedOrderCell: React.VFC<RelatedOrderCellProps> = ({ row }) => (
  <LinkToRelatedOrder orderId={row.original.createdFromOrder?.orderNumber} />
)
